import * as React from 'react';
export const InfoMessagesContext = React.createContext(null);
const InfoMessagesContextProvider = InfoMessagesContext.Provider;
export default InfoMessagesContextProvider;
